import React from 'react';
import { Menu, Bell, Plus, LogOut, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BranchSwitcher from './BranchSwitcher';
import ExchangeRateWidget from './ExchangeRateWidget';
import useLang from '../../i18n';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function Topbar({ title, onMenuClick }) {
  const { user, logout } = useAuthStore();
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    toast.success(t('success'));
  };

  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center px-4 gap-3 sticky top-0 z-40 flex-shrink-0">
      <button onClick={onMenuClick} className="lg:hidden p-2 rounded-lg hover:bg-gray-100 text-gray-500 flex-shrink-0">
        <Menu className="w-5 h-5" />
      </button>

      <h2 className="text-base font-bold text-gray-900 flex-1 truncate">{title}</h2>

      <div className="flex items-center gap-2">
        <ExchangeRateWidget />

        <button onClick={() => setLang(lang === 'da' ? 'en' : 'da')}
          className="hidden sm:flex items-center gap-1 px-2.5 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-xs font-bold text-gray-600 hover:bg-gray-100 transition-colors">
          {lang === 'da' ? 'EN' : 'دری'}
        </button>

        <BranchSwitcher />

        <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 relative">
          <Bell className="w-4 h-4" />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-red-500 rounded-full" />
        </button>

        <button onClick={() => navigate('/sales/new')}
          className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs font-bold rounded-xl hover:bg-blue-700">
          <Plus className="w-3.5 h-3.5" /> {t('newSale')}
        </button>

        <div className="relative group">
          <button className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-xs font-bold border-2 border-blue-200 hover:border-blue-400">
            {user?.name?.charAt(0) || 'U'}
          </button>
          <div className="absolute top-full left-0 mt-1.5 w-44 bg-white rounded-xl shadow-lg border border-gray-100 hidden group-hover:block py-1.5 z-50">
            <div className="px-3 py-2 border-b border-gray-50">
              <p className="text-xs font-bold text-gray-800 truncate">{user?.name}</p>
              <p className="text-[10px] text-gray-400 truncate">{user?.email}</p>
            </div>
            <button className="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-50" onClick={() => navigate('/settings')}>
              <Settings className="w-3.5 h-3.5" /> {t('settings')}
            </button>
            <button onClick={handleLogout} className="w-full flex items-center gap-2 px-3 py-2 text-xs text-red-600 hover:bg-red-50">
              <LogOut className="w-3.5 h-3.5" /> {t('logout')}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}